module.exports = __webpack_public_path__ + "static/media/next-steps-2.8d0f9eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/next-steps-2.png
// module id = 2634
// module chunks = 0